import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ANALYTICS_DATE_RANGES } from "../../../constants/buyerAnalyticsConstants";
import { LAUNCH_STATUS_LABELS } from "../../../constants/automapBuyerLaunchConstants";
import { fetchLaunchDashboard } from "../../../services/automapBuyerLaunchApi";
import { AnalyticsRangeSelect, AnalyticsSummaryGrid } from "../analytics/AdminAnalyticsShared";
import { LaunchShell } from "./AdminLaunchShared";

export default function AdminLaunchDashboardPage() {
  const [range, setRange] = useState("last_7_days");
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchLaunchDashboard(range).then(setPayload).finally(() => setLoading(false));
  }, [range]);

  const m = payload?.metrics;

  return (
    <LaunchShell
      active="launch"
      title="Launch campaign dashboard"
      description="Sesiones, leads y canales del lanzamiento comprador."
      viewEvent="launch_dashboard_viewed"
    >
      <AnalyticsRangeSelect range={range} onChange={setRange} options={ANALYTICS_DATE_RANGES} />
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {!loading && payload ? (
        <>
          <p>
            Estado: <strong>{LAUNCH_STATUS_LABELS[payload.config?.status] || payload.config?.status}</strong>
            {payload.costNote ? <span className="muted"> · {payload.costNote}</span> : null}
          </p>
          <AnalyticsSummaryGrid
            items={[
              { label: "Sesiones", value: m?.sessions },
              { label: "Búsquedas", value: m?.searchSessions },
              { label: "SEO sessions", value: m?.seoSessions },
              { label: "Detalle vehículo", value: m?.vehicleDetailViews },
              { label: "WhatsApp", value: m?.whatsappClicks },
              { label: "Leads", value: m?.leads },
              { label: "Calificados", value: m?.qualifiedLeads },
              { label: "Conv.", value: m?.leadConversionRate != null ? `${m.leadConversionRate}%` : "—" },
            ]}
          />
          {payload.alerts?.length ? (
            <section className="dealer-state-box">
              <h3>Alertas</h3>
              <ul>
                {payload.alerts.map((a) => (
                  <li key={a.id}>[{a.severity}] {a.title}: {a.description}</li>
                ))}
              </ul>
            </section>
          ) : null}
          <Link to="/admin/campaigns/launch/daily-monitor">Ir al daily monitor →</Link>
        </>
      ) : null}
    </LaunchShell>
  );
}
